import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null => loading, false => unauth, obj => auth
  const [initialized, setInitialized] = useState(false);

  const refreshMe = useCallback(async () => {
    const t = getToken();
    if (!t) {
      setUser(false);
      setInitialized(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      clearToken();
      setUser(false);
    } finally {
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    refreshMe();
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, username) => {
    const { data } = await api.post("/auth/register", { email, password, username });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const guest = async (username) => {
    const { data } = await api.post("/auth/guest", { username });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  const updateProfile = async (update) => {
    const { data } = await api.put("/profile", update);
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider
      value={{ user, initialized, login, register, guest, logout, updateProfile, refreshMe }}
    >
      {children}
    </AuthContext.Provider>
  );
}
